import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import * as moment from "moment";
import AlertModal from "components/AlertModal";
import { BuyBackWrapper, Container, Header, HeaderItem, Label, Value, BuybackTable, TableHeader, TableRow, TableCell, Footer } from "styles/pages/dashboard";
import { buyBackDetailsDashboardApi } from "redux/actions/dashboard";
import { formatCurrencyByCountry, getLoggedInUserCountry } from "helpers";

const BuybackDetails = (props) => {
  const { chartFilters } = props;
  const locale = props?.locale || ((key) => key);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loggedInUserInfo = JSON.parse(localStorage.getItem('loggedInUserData'))
  const userCountry = getLoggedInUserCountry();
  const token = loggedInUserInfo?.token
  const [buybackDetailsDataState, setBuybackDetailsDataState] = useState()
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");

  const fillTemplate = (template, values) =>
    Object.entries(values).reduce(
      (result, [key, value]) => String(result).split(`{${key}}`).join(value),
      template
    );

  useEffect(() => {
    if (chartFilters) fetchBuybackDetailsData()
  }, [chartFilters])

  const fetchBuybackDetailsData = async () => {
    let data = {
      locationIds: chartFilters?.locationIdList,
      startDate: moment(chartFilters?.fromDate).format('YYYY-MM-DD'),
      endDate: moment(chartFilters?.toDate).format('YYYY-MM-DD'),
      country: userCountry
    };
    let response = await dispatch(buyBackDetailsDashboardApi(data, token));
    if (response.data) {
      setBuybackDetailsDataState(response.data)
    } else {
      if (response?.data?.error?.message === "Invalid Token") {
        navigate("/");
      } else {
        setModalContent(response?.data?.error?.message || response.message || locale('genericErrorLater'));
        setModalLink("");
        setModal(!modal);
      }
    }
  };

  return (
    <BuyBackWrapper>
      <Container>
        <Header>
          <HeaderItem>
            <Label>{props.locale('avgPalletCost')}</Label>
            <Value>{buybackDetailsDataState?.averagePalletCost !== undefined && buybackDetailsDataState?.averagePalletCost !== null ? formatCurrencyByCountry(buybackDetailsDataState?.averagePalletCost, userCountry) : 'NA'}</Value>
          </HeaderItem>
          <HeaderItem style={{ background: '#E5ECF6' }}>
            <Label>{props.locale('avgBuyback')}</Label>
            <Value>{buybackDetailsDataState?.averageBuyBack !== undefined && buybackDetailsDataState?.averageBuyBack !== null ? formatCurrencyByCountry(buybackDetailsDataState?.averageBuyBack, userCountry) : 'NA'}</Value>
          </HeaderItem>
          <HeaderItem>
            <Label>{props.locale('netAvgCost')}</Label>
            <Value>{buybackDetailsDataState?.netAverageCost !== undefined && buybackDetailsDataState?.netAverageCost !== null ? formatCurrencyByCountry(buybackDetailsDataState?.netAverageCost, userCountry) : 'NA'}</Value>
          </HeaderItem>
        </Header>
        <p className='buybackHeader'>{props.locale('buybackBreakout')}</p>
        <BuybackTable>
          <thead>
            <tr>
              <TableHeader></TableHeader>
              <TableHeader>{props.locale('volume')}</TableHeader>
              <TableHeader>%</TableHeader>
            </tr>
          </thead>
          <tbody>
            {(buybackDetailsDataState?.buybackGradeList && buybackDetailsDataState?.buybackGradeList?.length > 0) ?
              (<>
                {buybackDetailsDataState?.buybackGradeList?.map(data => {
                  return (
                    <TableRow>
                      <TableCell>{data?.palletName}</TableCell>
                      <TableCell>{data?.numberOfOrder.toLocaleString('en-US')}</TableCell>
                      <TableCell>{data?.percentage}%</TableCell>
                    </TableRow>
                  )
                })}
                <TableRow>
                  <TableCell>{props.locale('total')}</TableCell>
                  <TableCell>{buybackDetailsDataState?.totalBuybackCount.toLocaleString('en-US')}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </>)
              :
              <p style={{ padding: '10px', textAlign: 'end', fontSize: '14px' }}>{props.locale('noDataAvailable')}</p>}
          </tbody>
        </BuybackTable>
      </Container>
      <Footer>
        <p className='header'>{locale('landfillAvoidance')}</p>
        <p className='content'>
          {fillTemplate(locale('landfillAvoidanceDescription'), {
            returnRate: buybackDetailsDataState?.returnRate ?? 0,
            reusedRate: buybackDetailsDataState?.reusedRate ?? 0,
            wasteLandfillValue: buybackDetailsDataState?.wasteLandfillValue?.toLocaleString('en-US') || 0,
            emissionLandfillValue: buybackDetailsDataState?.emissionLandfillValue?.toLocaleString('en-US') || 0,
          })}
        </p>
      </Footer>
      <AlertModal
        isOpen={modal}
        toggle={() => setModal(!modal)}
        title={locale('alert')}
        content={modalContent}
        link={modalLink}
        className="alert-msg-container"
        InnerClassName="alert-msg"
      />
    </BuyBackWrapper>
  );
};

export default BuybackDetails;
